export default "__VITE_PUBLIC_ASSET__7b626c99__"